import { Alert, Box, Button, Grid, TextField, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import esLocale from 'date-fns/locale/es';
import { actions } from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';
import moment from 'moment';
import ExcelButton from '../../../shared/ExcelButton';
import { getDayRange, verifyOrganization } from '../../../utils/utils';
import axios from 'axios';
const urlDialogflow = process.env.REACT_APP_DIALOGFLOW;
const urlExportKPI = process.env.REACT_APP_EXPORT_KPI;
const urlVerifyApi = process.env.REACT_APP_VERIFYAPI;
const useStyles = (small) => {
  return makeStyles((theme) => ({
    osButton: {
      marginBlock: 4,
      marginRight: 8,
      backgroundColor: theme.palette.randomColor8.main,
      color: 'white',
      '&:hover': {
        backgroundColor: theme.palette.randomColor8.light,
      },
    },
  }));
};

function Exports(props) {
  // define styles
  const small = useMediaQuery('(max-width:600px)');
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles(small)();

  // redux

  // hooks
  const appDispatch = useDispatch();
  const organization = useSelector((state) => state.app.organization);
  const firebase = useFirebase();

  // states
  const [initialDate, setInitialDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());
  const [excelInfo, setExcelInfo] = useState();
  const [openExcel, setOpenExcel] = useState({
    chatsByType: false,
    chatsByStatus: false,
    gestiones: false,
    gestionesByProfessional: false,
    gestionesBySpecialty: false,
    supportedUsers: false,
    supportedUsersPrestobots: false,
    verifyApi: false,
    notifications: false,
    obrassociales: false,
    contactsLeads: false,
    uniqueWppClientPhones: false,
    appointmentsCountBySession: false,
    cancellationSurvey: false,
    institutionalMessages: false,
    satisfactionSurvey: false,
    systemMessages: false,
  });

  // methods
  const handleExport = async () => {
    if (organization.id) {
      appDispatch({
        type: actions.changeLoading,
        loading: { loading: true, priority: 1 },
      });
      firebase
        .auth()
        .currentUser.getIdToken(true)
        .then(function (token) {
          // call to function
          axios(urlVerifyApi, {
            method: 'post',
            headers: {
              Authorization: `bearer ${token}`,
            },
            data: {
              organizationId: organization.id,
            },
          })
            .then((res) => {
              const data = res.data.data;
              const appointmentsInfo = data.map((appointmentInfo) => ({
                nombre: appointmentInfo.professional,
                especialidad: appointmentInfo.specialty,
                tiene_turnos: appointmentInfo.app ? 'SI' : 'NO',
              }));

              setExcelInfo(appointmentsInfo.sort((a, b) => (a.Nombre < b.Nombre ? -1 : 1)));
              setOpenExcel({ verifyApi: true });

              appDispatch({
                type: actions.changeLoading,
                loading: { loading: false, priority: 1 },
              });
              if (data.errors) {
                appDispatch({
                  type: actions.alert,
                  alert: {
                    snackbarOpen: true,
                    snackbarMessage: `Ocurrieron ${data.errors} errores al consultar la API`,
                    snackbarSeverity: 'error',
                  },
                });
              }
            })
            .catch((err) => {
              console.error('handleExport', err);
              const errorMessage =
                err.response.data.message || 'Ocurrió un error al consultar la API';

              appDispatch({
                type: actions.changeLoading,
                loading: { loading: false, priority: 1 },
              });
              appDispatch({
                type: actions.alert,
                alert: {
                  snackbarOpen: true,
                  snackbarMessage: errorMessage,
                  snackbarSeverity: 'error',
                },
              });
            });
        });
    }
  };

  const handleExportMetrics = (type) => {
    const [start] = getDayRange(initialDate);
    const [, end] = getDayRange(endDate);
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    axios(urlExportKPI, {
      method: 'POST',
      data: {
        type,
        initialDate: start.toDate(),
        endDate: end.toDate(),
        organizationId: organization.id,
      },
    })
      .then((res) => {
        const data = res.data;
        setExcelInfo(data.data);
        if (data.data && data.data.length > 0) {
          setOpenExcel({ [type]: true });
        } else {
          appDispatch({
            type: actions.alert,
            alert: {
              snackbarOpen: true,
              snackbarMessage: 'No vienen datos de la API',
              snackbarSeverity: 'error',
            },
          });
        }
      })
      .catch(() => {
        appDispatch({
          type: actions.alert,
          alert: {
            snackbarOpen: true,
            snackbarMessage: 'Ocurrio un error al consultar la API',
            snackbarSeverity: 'error',
          },
        });
      })
      .finally(() => {
        appDispatch({
          type: actions.changeLoading,
          loading: { loading: false, priority: 1 },
        });
      });
  };

  const handleClickDownload = (type) => {
    setTimeout(() => {
      setOpenExcel({ [type]: false });
    }, 100);
  };

  const exportNotFoundOS = () => {
    appDispatch({
      type: actions.changeLoading,
      loading: { loading: true, priority: 1 },
    });
    firebase
      .auth()
      .currentUser.getIdToken(true)
      .then(function (token) {
        axios(`${urlDialogflow}/verifyOS`, {
          method: 'post',
          headers: {
            Authorization: `bearer ${token}`,
          },
          data: {
            organizationId: organization.id,
          },
        })
          .then((res) => {
            if (res.data.notFoundOS.length === 0 && res.data.notFoundPlans.length === 0) {
              return appDispatch({
                type: actions.alert,
                alert: {
                  snackbarOpen: true,
                  snackbarMessage: `No hay nada que agregar`,
                  snackbarSeverity: 'info',
                },
              });
            }

            let data = [];
            if (res.data.notFoundOS.length > 0) {
              data = [...data, 'Obras sociales', ...res.data.notFoundOS, ''];
            }
            if (res.data.notFoundPlans.length > 0) {
              data = [...data, 'Planes', ...res.data.notFoundPlans];
            }
            navigator.clipboard.writeText(data.join('\n'));
            appDispatch({
              type: actions.alert,
              alert: {
                snackbarOpen: true,
                snackbarMessage: `Copiado en portapapeles`,
                snackbarSeverity: 'info',
              },
            });
          })
          .finally(() => {
            appDispatch({
              type: actions.changeLoading,
              loading: { loading: false, priority: 1 },
            });
          });
      });
  };

  // effects

  useEffect(() => {
    setExcelInfo(null);
  }, [organization.id]);

  return (
    <Box>
      <Typography>
        <b>EXPORTAR INFORMACIÓN</b>
      </Typography>
      <Box display="flex" pt={2}>
        <Box item sm={4}>
          <LocalizationProvider adapterLocale={esLocale} dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Desde"
              inputFormat="dd/MM/yyyy"
              value={initialDate}
              onChange={(date) => {
                setInitialDate(moment(new Date(date)));
              }}
              renderInput={(params) => <TextField {...params} />}
              disableFuture
            />
          </LocalizationProvider>
        </Box>
        <Box item sm={4} ml={1}>
          <LocalizationProvider adapterLocale={esLocale} dateAdapter={AdapterDateFns}>
            <DesktopDatePicker
              label="Hasta"
              inputFormat="dd/MM/yyyy"
              value={endDate}
              onChange={(date) => {
                setEndDate(moment(new Date(date)));
              }}
              renderInput={(params) => <TextField {...params} />}
              disableFuture
            />
          </LocalizationProvider>
        </Box>
      </Box>
      <Box mt={1}>
        <Alert severity="info">
          <Typography variant="body2" color="textSecondary">
            La fecha de inicio se tomará desde las <b>00:00 hs</b> del día seleccionado. La fecha de
            fin incluirá todo el día seleccionado, hasta las <b>23:59 hs</b>.
          </Typography>
        </Alert>
      </Box>
      <Box mt={2}>
        <Typography>Exportar para todos los clientes</Typography>
      </Box>
      <Grid container xs={12}>
        <ExcelButton
          name="Chat por tipo"
          color={1}
          open={openExcel.chatsByType}
          info={excelInfo}
          handleClose={() => handleClickDownload('chatsByType')}
          handleExport={() => handleExportMetrics('chatsByType')}
        />
        <ExcelButton
          name="Chats por estado"
          color={2}
          open={openExcel.chatsByStatus}
          info={excelInfo}
          handleClose={() => handleClickDownload('chatsByStatus')}
          handleExport={() => handleExportMetrics('chatsByStatus')}
        />
        <ExcelButton
          name="Gestiones por cliente"
          color={3}
          open={openExcel.gestiones}
          info={excelInfo}
          handleClose={() => handleClickDownload('gestiones')}
          handleExport={() => handleExportMetrics('gestiones')}
        />
        <ExcelButton
          name="Gestiones por profesional"
          color={4}
          open={openExcel.gestionesByProfessional}
          info={excelInfo}
          handleClose={() => handleClickDownload('gestionesByProfessional')}
          handleExport={() => handleExportMetrics('gestionesByProfessional')}
        />
        <ExcelButton
          name="Gestiones por especialidad"
          color={5}
          open={openExcel.gestionesBySpecialty}
          info={excelInfo}
          handleClose={() => handleClickDownload('gestionesBySpecialty')}
          handleExport={() => handleExportMetrics('gestionesBySpecialty')}
        />
        <ExcelButton
          name="Soporte de usuarios Prestobots"
          color={6}
          open={openExcel.supportedUsersPrestobots}
          info={excelInfo}
          handleClose={() => handleClickDownload('supportedUsersPrestobots')}
          handleExport={() => handleExportMetrics('supportedUsersPrestobots')}
        />
        <ExcelButton
          name="Notificaciones"
          color={7}
          open={openExcel.notifications}
          info={excelInfo}
          handleClose={() => handleClickDownload('notifications')}
          handleExport={() => handleExportMetrics('notifications')}
        />
        <ExcelButton
          name="Turnos por paciente"
          color={10}
          open={openExcel.appointmentsCountBySession}
          info={excelInfo}
          handleClose={() => handleClickDownload('appointmentsCountBySession')}
          handleExport={() => handleExportMetrics('appointmentsCountBySession')}
        />
      </Grid>
      <Box mt={4}>
        <Typography>Exportar para este cliente</Typography>
        <Box display="flex" alignItems="center" gap={2}>
          {verifyOrganization(organization) && (
            <ExcelButton
              name="Verificar agendas"
              color={8}
              open={openExcel.verifyApi}
              info={excelInfo}
              handleClose={() => handleClickDownload('verifyApi')}
              handleExport={() => handleExport()}
              header={`Turnos despues de ${
                (organization &&
                  organization.businessRules &&
                  organization.businessRules.fromThisDayOn) ||
                0
              } dias`}
            />
          )}
          <ExcelButton
            name="Obras sociales"
            color={8}
            open={openExcel.obrassociales}
            info={excelInfo}
            handleClose={() => handleClickDownload('obrassociales')}
            handleExport={() => handleExportMetrics('obrassociales')}
          />
          <Button
            variant="contained"
            onClick={exportNotFoundOS}
            className={classes.osButton}
            mr={2}
          >
            OS faltantes
          </Button>
          <ExcelButton
            name="Contactos Leads"
            color={8}
            open={openExcel.contactsLeads}
            info={excelInfo}
            handleClose={() => handleClickDownload('contactsLeads')}
            handleExport={() => handleExportMetrics('contactsLeads')}
          />
          <ExcelButton
            name="Numeros de Wpp unicos"
            color={8}
            open={openExcel.uniqueWppClientPhones}
            info={excelInfo}
            handleClose={() => handleClickDownload('uniqueWppClientPhones')}
            handleExport={() => handleExportMetrics('uniqueWppClientPhones')}
          />
          <ExcelButton
            name="Mensajes del sistema"
            color={8}
            open={openExcel.systemMessages}
            info={excelInfo}
            handleClose={() => handleClickDownload('systemMessages')}
            handleExport={() => handleExportMetrics('systemMessages')}
          />
        </Box>
      </Box>
      <Box mt={2}>
        <Box display="flex" alignItems="center" gap={2}>
          <ExcelButton
            name="Soporte de usuarios"
            color={13}
            open={openExcel.supportedUsers}
            info={excelInfo}
            handleClose={() => handleClickDownload('supportedUsers')}
            handleExport={() => handleExportMetrics('supportedUsers')}
          />
          <ExcelButton
            name="Encuesta cancelación"
            color={13}
            open={openExcel.cancellationSurvey}
            info={excelInfo}
            handleClose={() => handleClickDownload('cancellationSurvey')}
            handleExport={() => handleExportMetrics('cancellationSurvey')}
          />
          <ExcelButton
            name="Mensajes Institucionales"
            color={13}
            open={openExcel.institutionalMessages}
            info={excelInfo}
            handleClose={() => handleClickDownload('institutionalMessages')}
            handleExport={() => handleExportMetrics('institutionalMessages')}
          />
          <ExcelButton
            name="Encuesta de Satisfacción"
            color={13}
            open={openExcel.satisfactionSurvey}
            info={excelInfo}
            handleClose={() => handleClickDownload('satisfactionSurvey')}
            handleExport={() => handleExportMetrics('satisfactionSurvey')}
          />
        </Box>
      </Box>
    </Box>
  );
}

const Props = {};

Exports.propTypes = Props;

export default Exports;
